module.exports = __webpack_public_path__ + "img/japan.5ac5e61b.png";